import * as PIXI from 'pixi.js';
import { GameScene } from '@/types/GameState';

export class SceneManager {
  private app: PIXI.Application;
  private scenes: Map<GameScene, PIXI.Container>;
  private currentScene: GameScene | null = null;

  constructor(app: PIXI.Application) {
    this.app = app;
    this.scenes = new Map();
  }

  registerScene(sceneType: GameScene, scene: PIXI.Container): void {
    this.scenes.set(sceneType, scene);
  }

  switchTo(sceneType: GameScene): void {
    // Remove current scene
    if (this.currentScene !== null) {
      const current = this.scenes.get(this.currentScene);
      if (current) {
        this.app.stage.removeChild(current);
      }
    }

    // Add new scene
    const newScene = this.scenes.get(sceneType);
    if (newScene) {
      this.app.stage.addChild(newScene);
      this.currentScene = sceneType;
    } else {
      console.error(`Scene ${sceneType} not found`);
    }
  }

  getCurrentScene(): GameScene | null {
    return this.currentScene;
  }

  getScene(sceneType: GameScene): PIXI.Container | undefined {
    return this.scenes.get(sceneType);
  }
}
